import CustomError from 'common/CustomError';

export const USER_NOT_FOUND = 'USER_NOT_FOUND';
export const USER_EXISTS = 'USER_EXISTS';
export const UNCOMPLETE_USER_PROFILE = 'USER_NOT_FOUND';
export const UNKNOWN = 'UNKNOWN';
export const PERMISSION_DENIED = 'PERMISSION_DENIED';
export const UNAUTHENTICATED = 'UNAUTHENTICATED';

class BackendError extends CustomError {
  constructor(message, code) {
    super(message, code);
    this.name = 'BackendError';
  }
}

export default BackendError;
